import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Colors } from "../Colors/Colors";

function ConfirmRevokeUrlDialog({ handleCancelRevoke, handleConfirmRevoke }) {
  return (
    <Dialog
      title={"Confirm"}
      onClose={handleCancelRevoke}
    >
      <p style={{ margin: "25px", textAlign: "center", fontSize: 16 }}>
        Are you sure you want to revoke the URL?
      </p>
      <p style={{ margin: "25px", textAlign: "center", fontSize: 16 }}>
        This will make all previous job links for this company invalid.
      </p>
      <DialogActionsBar>
        <Button
          className="k-button"
          name={`btnRevokeUrlDialogNo`}
          style={{ backgroundColor: Colors.secondary }}
          onClick={handleCancelRevoke}
        >
          No
        </Button>
        <Button
          className="k-button"
          name={`btnRevokeUrlDialogYes`}
          style={{ backgroundColor: Colors.error }}
          onClick={handleConfirmRevoke}
        >
          Yes
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}

export default ConfirmRevokeUrlDialog;
